module.exports = __webpack_public_path__ + "img/UTHYRU-7.8870102e.jpg";